// watch-cart.js
//
// Added on May 14th by jeff@jeffthistle.com to facilitate a My Chemical Romance upsell promotion. If any of the
// 'targetVariants' variant ids are added to the cart, a one-time popup is displayed offering to push 'offerVariant'
// to the cart. 

// const targetVariants = [ 42344735965230 , 42344735997998 , 42344736030766 , 42344736063534 , 42344736096302 , 42344736129070 , 42344735768622 , 42344735801390 , 42344735834158 , 42344735866926 , 42344735899694 , 42344735932462 , 42344736686126 , 42344736718894 , 42344736751662 , 42344736784430 , 42344736817198 , 42344736849966 , 42344739176494 , 42344739209262 , 42344739242030 , 42344739274798 , 42344739307566 , 42344739340334 , 42344740159534 , 42344740192302 , 42344740225070 , 42344740257838 , 42344740290606 , 42344740323374 , 42344759885870 , 42344759918638 , 42344759951406 , 42344759984174 , 42344760016942 , 42344848261166 , 42344848293934 , 42344848326702 , 42344848359470 , 42344848392238 , 42344848883758 , 42344866938926 , 42344866971694 , 42344867004462 , 42344867037230 , 42344867069998 , 42344867102766 , 42344848949294 , 42344848982062 , 42344849014830 , 42344849047598 , 42344849080366 , 42344849113134 , 42344863825966 , 42344865398830 , 42344863825966 , 42344865890350 , 42344865988654 , 42344866873390 ];
// const offerVariant = 42344710537262;
const targetVariants = [ 42344735965230 , 42344735997998 , 42344736030766 , 42344736063534 , 42344736096302 , 42344736129070 , 42344735768622 , 42344735801390 , 42344735834158 , 42344735866926 , 42344735899694 , 42344735932462 , 42344736686126 , 42344736718894 , 42344736751662 , 42344736784430 , 42344736817198 , 42344736849966 , 42344739176494 , 42344739209262 , 42344739242030 , 42344739274798 , 42344739307566 , 42344739340334 , 42344740159534 , 42344740192302 , 42344740225070 , 42344740257838 , 42344740290606 , 42344740323374 , 42344759885870 , 42344759918638 , 42344759951406 , 42344759984174 , 42344760016942 , 42344848261166 , 42344848293934 , 42344848326702 , 42344848359470 , 42344848392238 , 42344848883758 , 42344866938926 , 42344866971694 , 42344867004462 , 42344867037230 , 42344867069998 , 42344867102766 , 42344848949294 , 42344848982062 , 42344849014830 , 42344849047598 , 42344849080366 , 42344849113134 , 42344863825966 , 42344865398830 , 42344863825966 , 42344865890350 , 42344865988654 , 42344866873390 ];   
const offerVariant = 42344710537262;

// Catch the add click
const { fetch: originalFetch } = window;
window.fetch = async (...args) => {
  const response = await originalFetch(...args);
  const url = args[0].toString();

  // If the URL is one of Shopify's cart endpoints
  if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update')) {    
    // Wait for the theme's own JS to finish, then fetch fresh cart state
    setTimeout(async () => {
      const freshRes = await originalFetch('/cart.js');
      const freshCart = await freshRes.json();
      checkCartForUpsell(freshCart);
    }, 1200); 
  }

  return response;
};

async function checkCartForUpsell(cart) {  

  console.log('checking for upsell');

  if (!cart || !cart.items) return;
 
  if (sessionStorage.getItem('upsell_shown') === 'true') return;

  // Check the items already present in the cart object
  const found = cart.items.some(item => targetVariants.includes(item.variant_id));
  if (!found) return;
  
  // Store that we've seen it
  sessionStorage.setItem('upsell_shown', 'true');

  // Try to find the message element, or create it if it doesn't exist
  let messageElement = document.getElementById('custom-upsell-message');

  if (!messageElement) {
    messageElement = document.createElement('div');
    messageElement.id = 'custom-upsell-message';
    
    // Initial Styles - You can move these to your CSS file instead
    Object.assign(messageElement.style, {
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)', // This perfectly centers the element
      zIndex: '2147483647',
      padding: '30px',
      backgroundColor: '#ffffff',
      color: '#333333',
      textAlign: 'center',
      borderRadius: '12px',
      boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
      width: '90%',
      maxWidth: '400px',
      border: '1px solid #ddd',
      display: 'none'
    });

    messageElement.innerHTML = `
      <button id="close-upsell-x" style="
        position: absolute;
        top: 10px;
        right: 10px;
        background: none;
        border: none;
        font-size: 24px;
        cursor: pointer;
        color: #999;
        line-height: 1;
        padding: 5px;
      ">&times;</button>
      <h3 style="margin: 0 0 10px 0; font-size: 20px;">GET 20% OFF</h3>
      <h3 style="margin: 0 0 10px 0; font-size: 20px;">Danger Days (Deluxe Edition) 2CD</h3>
      <img src="https://cdn.shopify.com/s/files/1/0809/0777/files/DD15_CD-Retail_1.png?v=1778769212" style="width: 200px;">
      <p style="margin-top: 8px; margin-bottom: 20px; color: #666; line-height: 1.5;">When you add it now</p>
      <button id="upsell-add-to-cart" style="
        background: #000;
        color: #fff;
        border: none;
        padding: 12px 24px;
        border-radius: 6px;
        cursor: pointer;
        width: 100%;
        font-weight: bold;
      ">Add To Cart</button>
    `;
    
    document.body.appendChild(messageElement);

    // Function to hide the message
    const hideMessage = () => {
      messageElement.style.display = 'none';
      // Optional: Add a class to prevent it from re-opening during this session
      messageElement.dataset.dismissed = 'true';
    };

    const addUpsellOffer = async () => {
        const formData = {
            'items': [{
            'id': offerVariant,
            'quantity': 1
            }]
        };

        try {
            const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
            });

            const data = await response.json();
            

            // // Trigger a refresh of the cart UI so the user sees the change
            // document.dispatchEvent(new CustomEvent('cart:updated', {
            // detail: { cart: data }
            // }));

            location.reload();
        } catch (error) {
            console.error('Error adding to cart:', error);
        }
    };

    // Attach listeners to both the X and the main button
    document.getElementById('close-upsell-x').addEventListener('click', hideMessage);
    document.getElementById('upsell-add-to-cart').addEventListener('click', addUpsellOffer);
  }

    messageElement.style.display = 'block';

}